__turbopack_export_value__({
  "stars": "Rating-module-scss-module__jlo3Wq__stars",
  "stars__star": "Rating-module-scss-module__jlo3Wq__stars__star",
  "stars__star_active": "Rating-module-scss-module__jlo3Wq__stars__star_active",
});
